/**
 * Returns true when the event target is inside a portaled HelpMenu panel.
 * Use in profile-menu outside-click handlers so link clicks are not swallowed.
 */
export function isHelpMenuPanelTarget(target) {
  return target instanceof Element && Boolean(target.closest('[data-help-menu-panel]'));
}
